module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d7ba504d330c928c261.worker.js");
};